export const get_data = async (id) => {
    try {
        const response = await axios.get(`api/subcontract/get_data/${id}`); // <- aca la data del supplier
        const data = response.data;
        let packerFda = '';

        if (data) { 
            if (data.contract.contract_suppliers[0].packer_company_id) {
                const responsePacker = await axios.get(`api/packer/get_packer/${data.contract.contract_suppliers[0].packer_company_id}`);
                const { data: dataPacker} = responsePacker;
                packerFda = dataPacker.fda || '';   
            }

            let obj = {
                "supplier"      : data.contract.contract_suppliers[0].supplier_company.Second_Title,
                "address"       : data.contract.contract_suppliers[0].ship_address.address,
                "packer"        : data.contract.contract_suppliers[0].packer_company_name,
                "packer_fda"    : packerFda,
                "payment"       : data.contract.contract_suppliers[0].payment_term,
                "terms"         : data.contract.contract_suppliers[0].Incoterm,
                "price"         : data.subcontract_product.supplier_price_detail ?? 0,
            }
            return obj;
        }
    } catch (error) {
        console.error('Error fetching contract:', error);
    }
}

export const get_data_customer = async (id) => {
    try {
        const response = await axios.get(`api/subcontract/get_data/${id}`); // <- aca la data del supplier
        const data = response.data;

        if (data) { 
            let obj = {
                "customer_po"       : data.contract.contract_customer[0].MasterPO,
                "company"           : data.contract.contract_customer[0].customer_company.Second_Title,
                "irs"               : data.contract.contract_customer[0].customer_company.irs,
                "address"           : data.contract.contract_customer[0].customer_company.BillAddress,
                "terms"             : data.contract.contract_customer[0].Incoterm_2,
                "payment"           : data.contract.contract_customer[0].payment_term,
                "price"             : data.subcontract_product.customer_price_detail,
                "commission"        : data.contract.contract_customer[0].Commission,
                "palletized"        : data.contract.load_method === 'Palletized' ? 'Yes' : 'No',
                "notes"             : data.contract.additional_info,
            }
            return obj;
        }
    } catch (error) {
        console.error('Error fetching contract:', error);
    }
}
